import React from 'react';
import styles from './AppLink.module.scss';
import iosBadge from '/img/start/ios.png?url';
import macosBadge from '/img/start/macos.png?url';
import webBadge from '/img/start/web.png?url';
import windowsBadge from '/img/start/windows.png?url';
import cn from 'classnames';
import analytics from '@repo/utils/helpers/analytics';
import { useTheme } from '@repo/themes';

type AppType = 'ios' | 'macos' | 'web' | 'windows';

interface AppLinkProps {
  className?: string;
  app: AppType;
}

const badges: Record<AppType, string> = {
  ios: iosBadge,
  macos: macosBadge,
  web: webBadge,
  windows: windowsBadge,
};

const applinks: Record<AppType, { href: string; target: string | null }> = {
  ios: {
    href: 'https://apps.apple.com/us/app/clay/id1463073824',
    target: '_blank',
  },
  macos: {
    href: 'https://clay.earth/api/download/mac',
    target: '_blank',
  },
  web: {
    href: '/',
    target: null,
  },
  windows: {
    href: 'https://clay.earth/api/download/windows',
    target: '_blank',
  },
};

const appTrackingType: Record<AppType, string> = {
  ios: 'iOS',
  macos: 'Mac',
  web: 'Web',
  windows: 'Windows',
};

export default function AppLink({ app }: AppLinkProps) {
  const [theme] = useTheme();
  const badgeImage = badges[app];
  const link = applinks[app];
  const actionText = app !== 'web' ? 'Download' : 'Open web app';

  function onLinkClick() {
    analytics.track('Onboarding Started', {
      type: appTrackingType[app],
    });
    analytics.trackStartPage('download', {
      type: appTrackingType[app],
    });
  }

  return (
    <a className={cn(styles.button, styles[app], styles[theme])} {...link} onClick={onLinkClick}>
      <div className={styles.badge}>
        <img className={styles.badgeImg} src={badgeImage} />
      </div>
      <div className={styles.clayFor}>Clay for {app}</div>
      <div className={styles.download}>{actionText}</div>
    </a>
  );
}
